import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/benchmarkScore/importer/benchmarkScoreImporterActions';

export default importerReducers(actions);
